<template>
  <div style="padding: 0px" class="sub-view">
    <div class="table-navigation">
      <!-- list filter -->
      <div></div>

      <!-- bagian untuk cari tambah dan download -->
      <div class="cari-tambah-download">
        <!-- box pencarian -->
        <div class="cari">
          <svg
            style="margin-right: 8px"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4286 13.4294L10.3214 10.3223M12 6.28655C12 9.44246 9.44161 12.0008 6.2857 12.0008C3.12978 12.0008 0.571411 9.44246 0.571411 6.28655C0.571411 3.13064 3.12978 0.572266 6.2857 0.572266C9.44161 0.572266 12 3.13064 12 6.28655Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <input
            v-model="filterData.pencarian"
            placeholder="Cari"
            type="text"
            name=""
            id=""
          />
        </div>
        <!-- button tambah -->
        <button @click="openCloseModalInput(true)" class="add">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.00003 5.14314V10.8574M5.14289 8.00028H10.8572M15.1429 8.00028C15.1429 11.9452 11.9449 15.1431 8.00003 15.1431C4.05514 15.1431 0.857178 11.9452 0.857178 8.00028C0.857178 4.05539 4.05514 0.857422 8.00003 0.857422C11.9449 0.857422 15.1429 4.05539 15.1429 8.00028Z"
              stroke="#FCFCFC"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <!-- open menu mobile -->
        <div class="open-menu-mobile">
          <!-- menu icon -->
          <svg
            @click="openCloseMenuMobile(true)"
            width="14"
            height="4"
            viewBox="0 0 14 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.99993 2.71422C7.39442 2.71422 7.71422 2.39442 7.71422 1.99993C7.71422 1.60544 7.39442 1.28564 6.99993 1.28564C6.60544 1.28564 6.28564 1.60544 6.28564 1.99993C6.28564 2.39442 6.60544 2.71422 6.99993 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.9999 2.71422C12.3944 2.71422 12.7142 2.39442 12.7142 1.99993C12.7142 1.60544 12.3944 1.28564 11.9999 1.28564C11.6054 1.28564 11.2856 1.60544 11.2856 1.99993C11.2856 2.39442 11.6054 2.71422 11.9999 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.99993 2.71422C2.39442 2.71422 2.71422 2.39442 2.71422 1.99993C2.71422 1.60544 2.39442 1.28564 1.99993 1.28564C1.60544 1.28564 1.28564 1.60544 1.28564 1.99993C1.28564 2.39442 1.60544 2.71422 1.99993 2.71422Z"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <!-- end of menu icon -->
          <div
            style="display: none"
            ref="box-pilihan-menu"
            class="box-pilihan-aksi"
          >
            <!-- tambah kategori-->
            <p @click="openCloseModalInput">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.00003 5.14265V10.8569M5.14289 7.99979H10.8572M15.1429 7.99979C15.1429 11.9447 11.9449 15.1426 8.00003 15.1426C4.05514 15.1426 0.857178 11.9447 0.857178 7.99979C0.857178 4.0549 4.05514 0.856934 8.00003 0.856934C11.9449 0.856934 15.1429 4.0549 15.1429 7.99979Z"
                  stroke="#FFB700"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              Tambah
            </p>
          </div>
        </div>
        <!-- end of open menu mobile -->
      </div>
    </div>
    <!-- end of bagian untuk cari tambah dan download -->

    <div class="box-table">
      <table>
        <!-- judul tabel  -->
        <tr>
          <th>ID Kategori</th>
          <th>Nama Kategori</th>
          <th>Tipe Transaksi</th>
          <th></th>
        </tr>
        <!-- start iterasi tabel -->
        <tr
          :key="id"
          v-for="(kategori, id, index) in mapKategoriBukukasFiltered"
        >
          <td>{{ id }}</td>
          <td>
            <p style="font-weight: 600; margin: 4px unset">
              {{ kategori.nama }}
            </p>
          </td>
          <td>
            <p>{{ kategori.tipeTransaksi }}</p>
          </td>

          <!-- action -->
          <td style="padding-left: 32px; position: relative">
            <svg
              @click="openCloseAction(true, index)"
              width="14"
              height="4"
              viewBox="0 0 14 4"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.99993 2.7147C7.39442 2.7147 7.71422 2.39491 7.71422 2.00042C7.71422 1.60593 7.39442 1.28613 6.99993 1.28613C6.60544 1.28613 6.28564 1.60593 6.28564 2.00042C6.28564 2.39491 6.60544 2.7147 6.99993 2.7147Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.9999 2.7147C12.3944 2.7147 12.7142 2.39491 12.7142 2.00042C12.7142 1.60593 12.3944 1.28613 11.9999 1.28613C11.6054 1.28613 11.2856 1.60593 11.2856 2.00042C11.2856 2.39491 11.6054 2.7147 11.9999 2.7147Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.99993 2.7147C2.39442 2.7147 2.71422 2.39491 2.71422 2.00042C2.71422 1.60593 2.39442 1.28613 1.99993 1.28613C1.60544 1.28613 1.28564 1.60593 1.28564 2.00042C1.28564 2.39491 1.60544 2.7147 1.99993 2.7147Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div
              style="display: none"
              ref="box-pilihan-aksi"
              class="box-pilihan-aksi"
            >
              <p @click="openCloseModalEdit(true, id)">
                <svg
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.561035 15.1431H13.4837M9.68292 0.857422L12.7235 3.71456L4.36182 11.5717H1.32119V8.71456L9.68292 0.857422Z"
                    stroke="#2F80ED"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Edit
              </p>
              <p @click="openCloseDeleteModal(true, id)">
                <svg
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.571289 3.71456H13.4284M4.14272 3.71456V2.28599C4.14272 1.90711 4.29323 1.54375 4.56114 1.27584C4.82905 1.00793 5.19241 0.857422 5.57129 0.857422H8.42843C8.80731 0.857422 9.17068 1.00793 9.43858 1.27584C9.70649 1.54375 9.857 1.90711 9.857 2.28599V3.71456M11.9999 3.71456V13.7146C11.9999 14.0934 11.8494 14.4568 11.5814 14.7247C11.3135 14.9926 10.9502 15.1431 10.5713 15.1431H3.42843C3.04955 15.1431 2.68619 14.9926 2.41828 14.7247C2.15037 14.4568 1.99986 14.0934 1.99986 13.7146V3.71456H11.9999Z"
                    stroke="#EB5757"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Hapus
              </p>
            </div>
          </td>
        </tr>

        <!-- end iterasi tabel -->
      </table>
      <p
        v-if="
          !Object.keys(mapKategoriBukukasFiltered) ||
          Object.keys(mapKategoriBukukasFiltered).length === 0
        "
        class="empty-state-table"
      >
        Belum ada data
      </p>
    </div>

    <!-- modal tambah kategori-->
    <ModalInput v-if="modalInputIsOpen">
      <div style="max-width: 730px" class="content">
        <h2>Tambah Kategori</h2>
        <!-- input form -->
        <div class="list-form-modal">
          <!-- id kategori -->
          <div ref="tambah-id-form" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28564 5.69351H12.7142M1.28564 10.3089H12.7142M5.57136 1.07812L4.14279 14.9243M9.85707 1.07812L8.4285 14.9243"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahKategori.id" class="input-title"
                >ID Kategori</span
              >
              <input
                v-model="tambahKategori.id"
                class="input-text"
                required
                placeholder="ID Kategori"
                type="text"
              />
            </div>
          </div>
          <!-- end of id kategori -->

          <!-- tipe transaksi -->
          <div class="keterangan">
            <div
              ref="tambah-tipeTransaksi-form"
              @click="openClosePilihanTransaksi(true)"
              class="box-form email"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857178 11.5717L8.00003 15.1431L15.1429 11.5717M0.857178 8.00028L8.00003 11.5717L15.1429 8.00028M8.00003 0.857422L0.857178 4.42885L8.00003 8.00028L15.1429 4.42885L8.00003 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="input-and-title">
                <span
                  v-if="tambahKategori.tipeTransaksi"
                  style="display: block"
                  class="input-title"
                  >Tipe transaksi</span
                >

                <p>
                  {{
                    tambahKategori.tipeTransaksi
                      ? tambahKategori.tipeTransaksi
                      : "Tipe Transaksi"
                  }}
                </p>
              </div>
            </div>
            <!-- box pilihan transaksi -->
            <div
              style="display: none"
              ref="boxPilihanTransaksi"
              class="box-pilihan"
            >
              <p
                :key="tipeTransaksi"
                v-for="tipeTransaksi in listTipeTransaksi"
                @click="openClosePilihanTransaksi(false, tipeTransaksi)"
              >
                {{ tipeTransaksi }}
                <svg
                  v-if="tambahKategori.tipeTransaksi === tipeTransaksi"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan transaksi -->
          </div>
          <!-- end of tipe transaksi -->

          <!-- nama -->
          <div ref="tambah-nama-form" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28564 5.69351H12.7142M1.28564 10.3089H12.7142M5.57136 1.07812L4.14279 14.9243M9.85707 1.07812L8.4285 14.9243"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahKategori.nama" class="input-title"
                >Nama Kategori</span
              >
              <input
                v-model="tambahKategori.nama"
                class="input-text"
                required
                placeholder="Nama Kategori"
                type="text"
              />
            </div>
          </div>
          <!-- end of nama -->
        </div>
        <!-- end of input form -->
        <hr />
        <button
          :disabled="isProcessing"
          @click="tambahkanKategori"
          style="margin: 20px"
          class="yellow-button"
        >
          <div ref="spinner" style="display: none" class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <span ref="button-text">Tambah Data</span>
        </button>
      </div>

      <!-- close button -->
      <svg
        style="margin-top: -279px"
        @click="openCloseModalInput(false)"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalInput>
    <!-- end of modal -->

    <!-- modal edit-->
    <ModalInput v-if="modalEditIsOpen">
      <div style="max-width: 730px" class="content">
        <h2>Edit Kategori</h2>
        <!-- input form -->
        <div class="list-form-modal">
          <!-- id kategori -->
          <div ref="edit-id-form" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28564 5.69351H12.7142M1.28564 10.3089H12.7142M5.57136 1.07812L4.14279 14.9243M9.85707 1.07812L8.4285 14.9243"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahKategori.id" class="input-title"
                >ID Kategori</span
              >
              <input
                v-model="tambahKategori.id"
                class="input-text"
                required
                placeholder="ID Kategori"
                type="text"
              />
            </div>
          </div>
          <!-- end of id kategori -->

          <!-- tipe transaksi -->
          <div class="keterangan">
            <div
              ref="edit-tipeTransaksi-form"
              @click="openClosePilihanTransaksi(true)"
              class="box-form email"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857178 11.5717L8.00003 15.1431L15.1429 11.5717M0.857178 8.00028L8.00003 11.5717L15.1429 8.00028M8.00003 0.857422L0.857178 4.42885L8.00003 8.00028L15.1429 4.42885L8.00003 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="input-and-title">
                <span
                  v-if="tambahKategori.tipeTransaksi"
                  style="display: block"
                  class="input-title"
                  >Tipe transaksi</span
                >

                <p>
                  {{
                    tambahKategori.tipeTransaksi
                      ? tambahKategori.tipeTransaksi
                      : "Tipe Transaksi"
                  }}
                </p>
              </div>
            </div>
            <!-- box pilihan transaksi -->
            <div
              style="display: none"
              ref="boxPilihanTransaksi"
              class="box-pilihan"
            >
              <p
                :key="tipeTransaksi"
                v-for="tipeTransaksi in listTipeTransaksi"
                @click="openClosePilihanTransaksi(false, tipeTransaksi)"
              >
                {{ tipeTransaksi }}
                <svg
                  v-if="tambahKategori.tipeTransaksi === tipeTransaksi"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan transaksi -->
          </div>
          <!-- end of tipe transaksi -->

          <!-- nama -->
          <div ref="edit-nama-form" class="box-form email">
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.28564 5.69351H12.7142M1.28564 10.3089H12.7142M5.57136 1.07812L4.14279 14.9243M9.85707 1.07812L8.4285 14.9243"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div class="input-and-title">
              <span v-if="tambahKategori.nama" class="input-title"
                >Nama Kategori</span
              >
              <input
                v-model="tambahKategori.nama"
                class="input-text"
                required
                placeholder="Nama Kategori"
                type="text"
              />
            </div>
          </div>
          <!-- end of nama -->
        </div>
        <!-- end of input form -->
        <hr />
        <button
          :disabled="isProcessing"
          @click="editKategori"
          style="margin: 20px"
          class="yellow-button"
        >
          <div ref="spinner" style="display: none" class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <span ref="button-text">Edit Data</span>
        </button>
      </div>

      <!-- close button -->
      <svg
        style="margin-top: -279px"
        @click="openCloseModalEdit(false)"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalInput>
    <!-- end of modal -->

    <!-- modal berhasil -->
    <ModalBerhasil v-if="modalBerhasilIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#00BA88" />
          <path
            d="M65.4526 42.0845V44.0121C65.45 48.5303 63.987 52.9267 61.2817 56.5454C58.5764 60.1642 54.7738 62.8116 50.441 64.0927C46.1082 65.3737 41.4773 65.2199 37.2391 63.6541C33.0009 62.0883 29.3824 59.1944 26.9232 55.4041C24.464 51.6137 23.296 47.13 23.5933 42.6215C23.8906 38.1131 25.6372 33.8215 28.5728 30.3869C31.5084 26.9523 35.4756 24.5586 39.8827 23.5629C44.2899 22.5672 48.9008 23.0227 53.0279 24.8616M65.4526 27.2502L44.5002 48.2236L38.2145 41.9378"
            stroke="#FCFCFC"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>Sukses Tambah Data</h2>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="openCloseModalBerhasil(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalBerhasil>
    <!-- end of modal berhasil -->

    <!-- modal view lampiran -->
    <ModalViewer v-if="modalViewerIsOpen">
      <div style="text-align: center" class="modal-content-viewer">
        <object
          style="object-fit: cover; margin: 10px 0px"
          :data="urlLampiran"
          width="750"
          height="390"
        ></object>

        <button
          @click="openDokumen"
          style="margin-top: 10px"
          class="yellow-button"
        >
          Buka dokumen
        </button>
      </div>
      <!-- close button -->
      <svg
        @click="openCloseModalViewer(false)"
        style="margin-top: -438px; margin-left: 340px"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalViewer>
    <!-- end of modal view lampiran -->

    <!-- modal delete -->
    <ModalDelete v-if="modalDeleteIsOpen">
      <div class="content">
        <!-- icon -->
        <svg
          style="margin-bottom: 22px"
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.5 88C68.8005 88 88.5 68.3005 88.5 44C88.5 19.6995 68.8005 0 44.5 0C20.1995 0 0.5 19.6995 0.5 44C0.5 68.3005 20.1995 88 44.5 88Z"
            fill="#EB5757"
          />
          <path
            d="M25.5356 30.8572H63.4642H25.5356ZM36.0714 30.8572V26.6429C36.0714 25.5252 36.5154 24.4533 37.3057 23.6629C38.096 22.8726 39.1679 22.4286 40.2856 22.4286H48.7142C49.8319 22.4286 50.9038 22.8726 51.6942 23.6629C52.4845 24.4533 52.9285 25.5252 52.9285 26.6429V30.8572H36.0714ZM59.2499 30.8572V60.3572C59.2499 61.4749 58.8059 62.5468 58.0156 63.3371C57.2253 64.1274 56.1533 64.5714 55.0356 64.5714H33.9642C32.8465 64.5714 31.7746 64.1274 30.9843 63.3371C30.1939 62.5468 29.7499 61.4749 29.7499 60.3572V30.8572H59.2499Z"
            stroke="#FCFCFC"
            stroke-width="5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!-- end of icon -->
        <div class="text-modal">
          <h2 class="primary-text">Yakin untuk menghapus data?</h2>
          <p style="text-align: center">
            Data yang terhapus tidak bisa dikembalikan
          </p>

          <div class="list-button">
            <button @click="hapusKategori" class="delete">Hapus</button>
            <button @click="openCloseDeleteModal(false)" class="cancel">
              Batal
            </button>
          </div>
        </div>
      </div>
      <!-- close button -->
      <svg
        @click="openCloseDeleteModal(false)"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalDelete>
    <!-- end of modal delete -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import ModalInput from "@/components/modal/ModalInput";
import ModalBerhasil from "@/components/modal/ModalAlert";
import ModalViewer from "@/components/modal/RelativeModal";
import ModalDelete from "@/components/modal/Modal";
import * as soluhafire from "@/soluhafire";

export default {
  components: {
    ModalInput,
    ModalBerhasil,
    ModalViewer,
    ModalDelete,
  },

  data() {
    return {
      isProcessing: false,
      deleteIndex: null,
      editIndex: null,
      deleteId: "",
      // status modal
      modalViewerIsOpen: false,
      modalInputIsOpen: false,
      modalEditIsOpen: false,
      modalBerhasilIsOpen: false,
      modalDeleteIsOpen: false,
      // filter
      filterData: {
        pencarian: "",
      },
      tambahKategori: {
        id: "",
        nama: "",
        tipeTransaksi: "",
      },
      // data modal view
      urlLampiran: "",
    };
  },

  methods: {
    openClosePilihanFilterKategori(isOpen, value) {
      let box = this.$refs.boxPilihanFilterKategori;
      if (isOpen) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.kategori = value;
      }
    },

    openClosePilihanKategori(isOpen, value) {
      let box = this.$refs.boxPilihanKategori;
      if (isOpen) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.tambahPajak.kategori = value;
      }
    },

    openClosePilihanKategoriMobile(isOpen, value) {
      let box = this.$refs.boxPilihanKategoriMobile;
      if (isOpen) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.kategori = value;
      }
    },

    // untuk tutup atau buku box pilihan
    openClosePilihanTransaksi(open, value) {
      let box = this.$refs.boxPilihanTransaksi;
      if (open) {
        box.style.display = "block";
      } else {
        this.tambahKategori.tipeTransaksi = value;
        box.style.display = "none";
      }
    },

    openCloseAction(open, index) {
      let box = this.$refs["box-pilihan-aksi"][index];
      // tutup box action yang lain
      this.$refs["box-pilihan-aksi"].forEach((refs) => {
        refs.style.display = "none";
      });
      if (open) {
        box.style.display = "block";
        this.chosenIndex = index;
      } else {
        box.style.display = "none";
      }
    },

    openCloseMenuMobile(isOpen) {
      let box = this.$refs["box-pilihan-menu"];
      if (isOpen) box.style.display = "block";
      else box.style.display = "none";
    },

    // cek perubahan input untuk munculin input title
    inputChanged(event) {
      let title = event.target.previousSibling;
      if (event.target.value.length > 0) title.style.display = "block";
      else title.sstyle.display = "none";
    },

    openCloseModalInput(isOpen) {
      this.openCloseMenuMobile(false);
      if (isOpen) this.modalInputIsOpen = true;
      else this.modalInputIsOpen = false;
    },

    openCloseModalEdit(isOpen, id) {
      if (isOpen) {
        this.modalEditIsOpen = true;
        this.editId = id;
        this.tambahKategori.id = id;
        this.tambahKategori.nama = this.mapKategoriBukukasFiltered[id].nama;
        this.tambahKategori.tipeTransaksi =
          this.mapKategoriBukukasFiltered[id].tipeTransaksi;
        this.openCloseAction(false, this.chosenIndex);
        // ambil data riwayat awal
      } else this.modalEditIsOpen = false;
    },

    // buka atau tutup modal berhasil
    openCloseModalBerhasil(isOpen) {
      if (isOpen) {
        this.modalBerhasilIsOpen = true;
      } else {
        this.modalBerhasilIsOpen = false;
      }
    },

    openCloseModalViewer(isOpen, url) {
      if (isOpen) {
        this.urlLampiran = url;
        this.modalViewerIsOpen = true;
      } else {
        this.urlLampiran = "";
        this.modalViewerIsOpen = false;
      }
    },

    checkFormTambah() {
      let valid = true;
      let tambahKategori = this.tambahKategori;

      if (!tambahKategori.id) {
        this.$refs["tambah-id-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (!tambahKategori.tipeTransaksi) {
        this.$refs["tambah-tipeTransaksi-form"].classList.add(
          "failed-box-form"
        );
        valid = false;
      }

      if (!tambahKategori.nama) {
        this.$refs["tambah-nama-form"].classList.add("failed-box-form");
        valid = false;
      }

      return valid;
    },

    checkFormEdit() {
      let valid = true;
      let tambahKategori = this.tambahKategori;

      if (!tambahKategori.id) {
        this.$refs["edit-id-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (!tambahKategori.tipeTransaksi) {
        this.$refs["edit-tipeTransaksi-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (!tambahKategori.nama) {
        this.$refs["edit-nama-form"].classList.add("failed-box-form");
        valid = false;
      }

      return valid;
    },

    async tambahkanKategori() {
      let check = this.checkFormTambah();
      this.loader(true);
      if (check) {
        await soluhafire.ubahKategoriBukukas(
          this.userData.penempatan,
          this.tambahKategori.id,
          this.tambahKategori.nama,
          this.tambahKategori.tipeTransaksi
        );
        this.loader(false);
        this.openCloseModalBerhasil(true);
        this.openCloseModalInput(false);
        this.tambahKategori.id = "";
        this.tambahKategori.nama = "";
        this.tambahKategori.tipeTransaksi = "";
      } else {
        this.loader(false);
        return;
      }
    },

    async editKategori() {
      let check = this.checkFormEdit();
      this.loader(true);
      if (check) {
        await soluhafire.ubahKategoriBukukas(
          this.userData.penempatan,
          this.tambahKategori.id,
          this.tambahKategori.nama,
          this.tambahKategori.tipeTransaksi
        );
        this.loader(false);
        this.openCloseModalBerhasil(true);
        this.openCloseModalEdit(false);
        this.tambahKategori.id = "";
        this.tambahKategori.nama = "";
        this.tambahKategori.tipeTransaksi = "";
      } else {
        this.loader(false);
        return;
      }
    },

    hapusKategori() {
      soluhafire.hapusKategoriBukukas(this.userData.penempatan, this.deleteId);
      this.deleteId = null;
      this.openCloseDeleteModal(false);
    },

    openDokumen() {
      window.open(this.urlLampiran, "_blank");
    },

    // untuk tutup atau buka modal
    openCloseDeleteModal(isOpen, id) {
      if (isOpen) {
        this.deleteId = id;
        this.modalDeleteIsOpen = true;
        this.openCloseAction(false, this.chosenIndex);
      } else {
        this.deleteId = "";
        this.modalDeleteIsOpen = false;
      }
    },

    dateToEpoch(date) {
      let time = new Date(date);
      return time.getTime();
    },

    loader(isLoading) {
      let textButton = this.$refs["button-text"];
      let spinner = this.$refs["spinner"];

      if (isLoading) {
        textButton.style.display = "none";
        spinner.style.display = "block";
        this.isProcessing = true;
      } else {
        textButton.style.display = "block";
        spinner.style.display = "none";
        this.isProcessing = false;
      }
    },
  },

  computed: {
    ...mapState(["listTipeTransaksi", "mapKategoriBukukas", "userData"]),
    mapKategoriBukukasFiltered() {
      // Shallow copy the object
      let mapKategoriBukukas = this.mapKategoriBukukas;
      let filterPencarian = this.filterData.pencarian.toLowerCase();

      let result = {};
      if (mapKategoriBukukas) {
        for (let key in mapKategoriBukukas) {
          let val = mapKategoriBukukas[key];
          let passFlag = true;
          if (filterPencarian && filterPencarian.length > 0) {
            passFlag = val.nama.toLowerCase().includes(filterPencarian);
            if (!passFlag) continue;
          }

          if (passFlag) {
            result[key] = val;
          }
        }
        return result;
      }
      return false;
    },
  },
};
</script>
